module.exports = __webpack_public_path__ + "static/img/10.9638b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/10.png
// module id = +nx3
// module chunks = 0